import { render, staticRenderFns } from "./LearningActivityIcon.vue?vue&type=template&id=44786772"
import script from "./LearningActivityIcon.vue?vue&type=script&lang=js"
export * from "./LearningActivityIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports